import React from 'react'

const Spacer = () => <hr style={{ borderLeft: '1px solid black' }} />

export default Spacer
